import React, { useState } from 'react'
import styles from '../style'
import propTypes from '../prop'
import {
  withStyles,
  ImageListItemBar,
  Chip,
  Tooltip,
  Typography,
} from '@material-ui/core'
import withMediaLayout from '../layout-hoc'
import ConverterDateToShortFormat from '../../../../utils/converter/date-to-short-format'
import Zoom from '@material-ui/core/Zoom'
import translator from '../../../../translate'
import ClassNames from 'classnames'
import { CoreIconButton } from 'src/components/core'
import {
  ButtonType,
  ButtonData,
  ButtonActionType,
} from '../../../../model/button'
import MessageBoxContent, {
  MessageBoxType,
} from '../../../../model/message-box'
import {
  messageBoxShowAction,
  messageBoxHideAction,
} from '../../../../reducers/message-box/action'

import { mediaVideoDeleteAction } from '../../../../reducers/media-video/action'
import { Icon } from '@iconify/react'

/**
 *
 * @param {*} props
 */
const MediaItemVideo = props => {
  const {
    classes,
    thumbnailSmallLink,
    name,
    createDate,
    onSelect,
    refreshList,
    selected,
    id,
    dispatch,
    status,
  } = props

  const [hideItem, setHideItem] = useState(true)
  const [displayItem, setDisplayItem] = useState('block')

  /**
   *
   */
  const handleSelect = () => {
    onSelect(props)
  }
  const onDelete = () => {
    dispatch(
      messageBoxShowAction(
        MessageBoxContent({
          type: MessageBoxType.WARNING,
          buttons: [
            new ButtonData(
              ButtonType.NORMAL,
              translator._('action.no'),
              ButtonActionType.NO,
              () => {
                dispatch(messageBoxHideAction())
              },
            ),
            new ButtonData(
              ButtonType.ACTION,
              translator._('action.yes'),
              ButtonActionType.DELETE,
              () => {
                dispatch(
                  mediaVideoDeleteAction({ id }, () => {
                    dispatch(messageBoxHideAction())
                    setHideItem(false)
                  }),
                )
              },
            ),
          ],
          title: translator._('message.deleteVideo'),
        }),
      ),
    )
  }

  const uploadError = () => {
    return (
      <Zoom
        in={hideItem}
        onExited={() => setDisplayItem('none')}
        appear={false}
      >
        <div
          style={{
            background: '#5d473f',
            height: '100%',
            display: displayItem,
            overflow: 'hidden',
          }}
        >
          <div
            style={{
              overflow: 'hidden',
              width: '100%',
              height: 150,
            }}
          >
            <img
              src="/assets/codec-error.gif"
              className={classes.imageContent}
              alt=""
              draggable={false}
            />
          </div>

          <CoreIconButton
            color="dark"
            variant="text"
            size="small"
            onClick={onDelete}
          >
            <Icon icon="bx:trash-alt" />{' '}
          </CoreIconButton>
          <Tooltip title={name || '-'}>
            <>
              <ImageListItemBar
                style={{ height: 'auto' }}
                title={name || '-'}
                subtitle={ConverterDateToShortFormat(createDate)}
                className={ClassNames({
                  [classes.selected]: selected,
                })}
                actionPosition="right"
                classes={{
                  root: classes.titleBar,
                  title: classes.title,
                  subtitle: classes.subtitle,
                  titleWrapActionPosRight: classes.titleWrapActionPosRight,
                }}
                actionIcon={
                  <Chip
                    label={translator._('media.codecError')}
                    size="small"
                    className={classes.chip}
                  />
                }
              />
            </>
          </Tooltip>
        </div>
      </Zoom>
    )
  }

  const uploading = () => {
    return (
      <Zoom
        in={hideItem}
        onExited={() => setDisplayItem('none')}
        appear={false}
      >
        <div
          style={{
            background: '#fff',
            height: '100%',
            display: displayItem,
          }}
        >
          <div className={classes.processing}>
            <Tooltip title="Refresh">
              <CoreIconButton
                className={classes.titleWrapActionPosRight}
                color="white"
                variant="contained"
                size="small"
                onClick={() => refreshList()}
              >
                <Icon icon="mdi:refresh" />
              </CoreIconButton>
            </Tooltip>
          </div>

          <CoreIconButton
            className={classes.deleteButton}
            color="white"
            variant="contained"
            size="small"
            onClick={onDelete}
          >
            <Icon icon="bx:trash-alt" />{' '}
          </CoreIconButton>
          <Tooltip title={<Typography>{name || '-'}</Typography>}>
            <div className={classes.titleBar}>
              <div
                style={{
                  width: '100%',
                }}
              >
                <Typography
                  className={classes.title}
                  style={{
                    display: '-webkit-box',
                    WebkitLineClamp: 1,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    width: '100%', // Accounting for padding and action button width
                    wordBreak: 'break-word',
                    lineHeight: '1.4em',
                    maxHeight: '2.4em', // 2 lines * 1.2em line-height
                    textAlign: 'center',
                  }}
                >
                  <Typography>Processing...</Typography>
                </Typography>
              </div>
            </div>
          </Tooltip>
        </div>
      </Zoom>
    )
  }

  const available = () => {
    return (
      <Zoom
        in={hideItem}
        onExited={() => setDisplayItem('none')}
        appear={false}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <div
            className={classes.bordersHolder}
            style={{
              display: displayItem,
            }}
          >
            <div className={classes.imageViewContainer}>
              <img
                src={
                  thumbnailSmallLink
                    ? thumbnailSmallLink
                    : '/assets/video_loading-2.gif'
                }
                className={classes.imageContent}
                alt=""
                onClick={handleSelect}
                draggable={false}
              />
            </div>
            <CoreIconButton
              className={classes.deleteButton}
              color="white"
              variant="contained"
              size="small"
              onClick={onDelete}
            >
              <Icon icon="bx:trash-alt" />
            </CoreIconButton>
            <CoreIconButton
              size="small"
              variant="contained"
              color="primary"
              onClick={handleSelect}
              className={classes.titleWrapActionPosRight}
            >
              {selected && !thumbnailSmallLink && (
                <Icon icon="ph:hourglass-light" />
              )}
              {!selected && <Icon icon="ic:round-plus" />}
            </CoreIconButton>
          </div>
          <Tooltip title={<Typography>{name || '-'}</Typography>}>
            <div
              className={classes.titleBar}
              style={{
                padding: '4px',
                cursor: 'pointer',
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <div
                style={{
                  width: '100%',
                }}
              >
                <Typography
                  className={classes.title}
                  style={{
                    display: '-webkit-box',
                    WebkitLineClamp: 1,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    width: '100%', // Accounting for padding and action button width
                    wordBreak: 'break-word',
                    lineHeight: '1.4em',
                    maxHeight: '2.4em', // 2 lines * 1.2em line-height
                    textAlign: 'center',
                  }}
                >
                  {name || '-'}
                </Typography>
                <Typography className={classes.subtitleAdditional}>
                  {ConverterDateToShortFormat(createDate)}
                </Typography>
              </div>
            </div>
          </Tooltip>
        </div>
      </Zoom>
    )
  }

  if (status === 'uploading_error') {
    return uploadError()
  } else if (status === 'available') {
    return available()
  } else {
    return uploading()
  }
}

MediaItemVideo.propTypes = propTypes

export default withMediaLayout(withStyles(styles)(MediaItemVideo))
